import type JSONAPISerializer from '@ember-data/serializer/json-api';

import ApplicationSerializer from './application';

export default class InviteSerializer extends ApplicationSerializer {
  attrs = {
    anonymizedAt: {
      serialize: false,
    },
    createdAt: {
      serialize: false,
    },
    creator: {
      serialize: false,
    },
    visitorDocuments: {
      serialize: false,
    },
    locationNames: {
      serialize: false,
    },
    visitApproval: {
      serialize: false,
    },
  };

  normalize(...args: Parameters<JSONAPISerializer['normalize']>): ReturnType<JSONAPISerializer['normalize']> {
    const hash = <{ relationships: { flow?: { data?: { id: string } } } }>args[1];

    // flow relationship comes back as an empty id for workplace. Remove that so ember data doesn't error.
    if (hash.relationships && !hash.relationships['flow']?.data?.id) delete hash.relationships['flow'];
    return super.normalize(...args);
  }

  serializeIntoHash(...args: Parameters<ApplicationSerializer['serializeIntoHash']>): void {
    const [hash, , snapshot, options] = args;
    const payload = this.serialize(snapshot, options!) as Record<string, unknown>;
    const adapterOptions = snapshot.adapterOptions as { workflowReevaluationReason?: string | null } | undefined;

    if (adapterOptions && 'workflowReevaluationReason' in adapterOptions) {
      const reason = adapterOptions.workflowReevaluationReason;
      const trimmed = typeof reason === 'string' ? reason.trim() : '';
      const meta = (payload['meta'] ?? {}) as Record<string, unknown>;
      meta['reason'] = trimmed ? trimmed : null;
      payload['meta'] = meta;
    }

    Object.assign(hash, payload);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    invite: InviteSerializer;
  }
}
